import React, { MutableRefObject } from 'react'
import moment from 'moment'

import useBlink from '../../hooks/useBlink'

import { Value, UOM, Wrapper, Icon, Label, LastUpdate } from '../../style'

function isEmpty(value: string): boolean {
    return ['', value].join('') === ''
}

function alertType(
    icon: string,
    color: string,
    defaultIconColor: string
): { icon: string; bgcolor: string; color: string } | null {
    return icon ? { icon: `fa-${icon}`, bgcolor: color || defaultIconColor || '#808080', color: '#fff' } : null
}

const Block: React.FC<BlockProps> = ({
    mnemonic,
    title,
    backgroundColor,
    nColumns,
    titleFontSize,
    titleBold,
    lastTimestamp,
    value,
    __html,
    __titleHtml,
    __blink,
    color,
    __uom,
    valueBold,
    valueFontSize,
    uomBold,
    uomFontSize,
    iconColor,
    defaultIconColor,
    clickHandler,
    __icon
}: BlockProps) => {
    const ref: MutableRefObject<HTMLDivElement> = useBlink(backgroundColor, __blink)
    const flexBasis = `${100 / nColumns - 2}%`
    const opacity = isEmpty(value) ? 0.5 : null
    const iconProps = alertType(__icon, iconColor, defaultIconColor)

    return (
        <Wrapper data-testid="card" style={{ flexBasis, opacity, borderColor: color }} ref={ref}>
            {iconProps ? (
                <Icon
                    color={iconProps.color}
                    bgcolor={iconProps.bgcolor}
                    className={`fas ${iconProps.icon} boxStatus`}
                    data-testid="icon"
                    onClick={clickHandler && (() => clickHandler(mnemonic))}
                />
            ) : null}
            <Label titleFontSize={titleFontSize} titleBold={titleBold}>
                {__titleHtml ? <span dangerouslySetInnerHTML={{ __html: __titleHtml }}></span> : title ?? mnemonic}
            </Label>

            <Value valueFontSize={valueFontSize} valueBold={valueBold}>
                {__html ? (
                    <div dangerouslySetInnerHTML={{ __html }} />
                ) : isEmpty(value) ? (
                    '-'
                ) : (
                    <>
                        {value}{' '}
                        <UOM uomBold={uomBold} uomFontSize={uomFontSize}>
                            {__uom}
                        </UOM>
                    </>
                )}
            </Value>
            {lastTimestamp ? <LastUpdate>{moment(lastTimestamp).fromNow()}</LastUpdate> : null}
        </Wrapper>
    )
}

export default Block
